/**
 * Onglets — motif ARIA : un seul panneau visible, les flèches naviguent
 * entre les onglets et le focus suit.
 *
 * Sans script, tous les panneaux sauf le premier portent `hidden` : le
 * contenu reste dans le HTML servi, donc lisible par un moteur de recherche,
 * et le premier onglet — le plus consulté — s'affiche normalement.
 */
function panneau(onglet) {
  return document.getElementById(onglet.getAttribute('aria-controls'));
}

function activer(onglet) {
  const liste = onglet.closest('[role="tablist"]');
  liste.querySelectorAll('[role="tab"]').forEach((autre) => {
    const actif = autre === onglet;
    autre.setAttribute('aria-selected', String(actif));
    autre.tabIndex = actif ? 0 : -1;
    const pan = panneau(autre);
    if (pan) pan.hidden = !actif;
  });
}

document.addEventListener('click', (event) => {
  const onglet = event.target.closest('.pi-tab[role="tab"]');
  if (onglet) activer(onglet);
});

document.addEventListener('keydown', (event) => {
  const onglet = event.target.closest('.pi-tab[role="tab"]');
  if (!onglet) return;

  const pas = { ArrowRight: 1, ArrowLeft: -1, Home: 'debut', End: 'fin' }[event.key];
  if (pas === undefined) return;
  event.preventDefault();

  const onglets = [...onglet.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
  const rang = onglets.indexOf(onglet);
  let cible;
  if (pas === 'debut') cible = onglets[0];
  else if (pas === 'fin') cible = onglets[onglets.length - 1];
  // La liste boucle : après le dernier onglet vient le premier.
  else cible = onglets[(rang + pas + onglets.length) % onglets.length];

  activer(cible);
  cible.focus();
});
